/**
 * Created by jonas on 2020-09-17.
 */


import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";

import {gsap} from "gsap";
import {KitchenDramaSushiManiaTextStyles} from "../config/KitchenDramaSushiManiaTextStyles";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {TwoLayerText} from "../components/TwoLayerText";
import {MathUtils} from "../utils/MathUtils";
import {KitchenDramaSushiManiaStatics} from "../utils/KitchenDramaSushiManiaStatics";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {KitchenDramaSushiManiaGameAssets} from "../KitchenDramaSushiManiaGameAssets";
import {TweenParticleEmitter} from "../utils/TweenParticleEmitter";
import {PropertyNode} from "pixi-particles";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";


export enum WinSize {
    none = 0,
    tiny,
    small,
    medium,
    large,
    big,
    mega,
    superMega
}

export class KitchenDramaSushiManiaWinView extends PIXI.Container implements StageLayer {
    private _countUp:BasicBitmapCountUp;
    private _countContainer:PIXI.Container;
    private _winAmountToggle:PIXI.BitmapText;

    private countUpLayer:PIXI.Container;
    private winWayLayer:PIXI.Container;
    private _floaterContainer:PIXI.Container;
    private _texts:TwoLayerText[] = [];


    private _winAmountBoundingBox = new PIXI.Rectangle(-330, -270, 660, 450);
    private _winAmountBoundingBoxMask = new PIXI.Rectangle(-230, -225, 460, 350);
    private _centerPoint:PIXI.Point = new PIXI.Point(0, 0);
    private _textTls:gsap.core.Timeline[] = [];
    private _blackHoleContainer:PIXI.Container;
    private _blackHole:TimelineSprite;
    private _blackHoleAnimation:gsap.core.Timeline;
    private _buildUpContainer:PIXI.Container;

    private _explosion:TweenParticleEmitter;
    private _particleConfig:any = {
        "alpha":{
            "start":1,
            "end":1
        },
        "scale":{
            "start":1,
            "end":0.01,
            "minimumScaleMultiplier":0.2
        },
        "color":{
            "start":"#ffffff",
            "end":"#ffffff"
        },
        "speed":{
            "start":800,
            "end":-200,
            "minimumSpeedMultiplier":0.2
        },
        "acceleration":{
            "x":0,
            "y":0
        },
        "maxSpeed":0,
        "startRotation":{
            "min":0,
            "max":360
        },
        "noRotation":true,
        "rotationSpeed":{
            "min":0,
            "max":0
        },
        "lifetime":{
            "min":1,
            "max":1.5
        },
        "blendMode":"normal",
        "frequency":0.001,
        "emitterLifetime":0.1,
        "maxParticles":200,
        "pos":{
            "x":0,
            "y":0
        },
        "addAtBack":false,
        "spawnType":"circle",
        "spawnCircle":{
            "x":0,
            "y":0,
            "r":0
        }
    };
    private _floaterAnimation:gsap.core.Timeline | undefined;
    private _finalAmountText:TwoLayerText;


    constructor() {
        super();
        this.name = "KitchenDramaSushiManiaWinView";
        this.init();
    }

    private init() {
        this._countUp = new BasicBitmapCountUp(KitchenDramaSushiManiaTextStyles.WIN_COUNT_UP, 700, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(0, 0);

        this._countContainer = new PIXI.Container();
        this._countContainer.position.set(360, 280);
        this._countContainer.addChild(this._countUp);


        this._winAmountToggle = new PIXI.BitmapText("", KitchenDramaSushiManiaTextStyles.WIN_COUNT_UP_TOGGLE);
        this._winAmountToggle.anchor = new PIXI.Point(0.5, 0.5);

        this.countUpLayer = new PIXI.Container();
        this.winWayLayer = new PIXI.Container();

        this._buildUpContainer = new PIXI.Container();


        this._floaterContainer = new PIXI.Container();
        this._floaterContainer.position.set(360, 360);

        this._blackHoleContainer = new PIXI.Container();
        this._blackHoleContainer.position.set(360, 360);
        this._blackHole = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.BLACK_HOLE_ANIMATION));
        this._blackHole.position.set(this._centerPoint.x, this._centerPoint.y);
        this._blackHole.anchor.set(0.5, 0.5);
        this._blackHoleContainer.addChild(this._blackHole);
        this._blackHoleAnimation = gsap.timeline({repeat:-1});
        this._blackHoleAnimation.add(this._blackHole.getAnimation());
        this.resetBlackHole();

        this._buildUpContainer.addChild(this._floaterContainer);
        this._buildUpContainer.addChild(this._blackHoleContainer);

        this._explosion = new TweenParticleEmitter(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.WIN_PARTICLE), this._particleConfig);
        this._explosion.position.set(360, 360);
        this._buildUpContainer.addChild(this._explosion);


        /*
                const gfx1 = new PIXI.Graphics();
                gfx1.beginFill(0xff0000);
                gfx1.drawRect(
                    this._winAmountBoundingBox.x,
                    this._winAmountBoundingBox.y,
                    this._winAmountBoundingBox.width,
                    this._winAmountBoundingBox.height
                );
                gfx1.endFill();

                const gfx2 = new PIXI.Graphics();
                gfx2.beginFill(0x00ff00);
                gfx2.drawRect(
                    this._winAmountBoundingBoxMask.x,
                    this._winAmountBoundingBoxMask.y,
                    this._winAmountBoundingBoxMask.width,
                    this._winAmountBoundingBoxMask.height
                );
                gfx2.endFill();
                this._floaterContainer.addChild(gfx1);
                this._floaterContainer.addChild(gfx2);

        */

        this.addChild(this.winWayLayer);
        this.addChild(this._buildUpContainer);
        this.addChild(this.countUpLayer);

    }

    public getCountUpScaleAnimation(fromCount:number, toCount:number, duration:number, fromScale:number, toScale:number):gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(() => {
            this._countUp.scale.set(fromScale, fromScale);
            this._countUp.preCalculateScale(fromCount, toCount);
        });

        tl.add(gsap.to(this._countUp.scale, {duration:duration, x:toScale, y:toScale, ease:"none"}));

        return tl;
    }

    public getWinCountUp(from:number, to:number, duration:number, pos:PIXI.Point = new PIXI.Point(360, 360), shouldPump:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        const pumpAnim = gsap.timeline();
        if (shouldPump) {
            pumpAnim.add(gsap.to(this._countContainer.scale, {duration:0.05, x:1.2, y:1.2, ease:"none"}));
            pumpAnim.add(gsap.to(this._countContainer.scale, {duration:0.3, x:1, y:1}));
        }

        tl.add(() => {
            /*            if (!KitchenDramaSushiMania.isWinBelowStake()) {
                            KitchenDramaSushiMania.soundPlayer.playWinSound();
                        }*/
            this._countContainer.alpha = 1;
            this._countContainer.position.set(pos.x, pos.y);
            this.countUpLayer.addChild(this._countContainer);
        });

        tl.add([
            this._countUp.getCountAnimation(from, to, duration),
            pumpAnim
        ]);

        tl.add(() => {
            this._countUp.stopAt(to, false);
        });


        return tl;
    }

    public getWinCountUpEnd(accumulatedRoundWin:number, stayDuration:number) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            /*            if (!KitchenDramaSushiMania.isWinBelowStake()) {
                            KitchenDramaSushiMania.soundPlayer.endCountUp();
                        }*/
            this.countUpLayer.addChild(this._countContainer);
        });
        tl.add(() => {
            this._countUp.stopAt(accumulatedRoundWin, false);
        });

        tl.add(gsap.to(this, {duration:stayDuration}));

        return tl;
    }

    public getWinCountUpFade(accumulatedRoundWin:number, fadeDuration:number = 0.3) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add([
            gsap.to(this._countContainer, {duration:fadeDuration, alpha:0, ease:"none"}),
            gsap.to(this._countContainer.position, {duration:fadeDuration, y:-100, ease:"none"})
        ]);
        tl.add(() => {
            this.countUpLayer.removeChild(this._countContainer);
            this._countContainer.alpha = 1;
            this._countContainer.position.set(0, 0);
        });

        return tl;
    }


    public addBetLineWinFloater(amount:number, fromReelPos?:PIXI.Point):gsap.core.Timeline {
        let tl:gsap.core.Timeline = gsap.timeline();
        const startPos = new PIXI.Point(0, 0);

        if (fromReelPos) {
            startPos.x = fromReelPos.x * KitchenDramaSushiManiaStatics.SYMBOL_WIDTH * 0.9 + KitchenDramaSushiManiaStatics.REEL_X_OFFSET - this._floaterContainer.x + KitchenDramaSushiManiaStatics.SYMBOL_WIDTH * 0.45;
            startPos.y = fromReelPos.y * KitchenDramaSushiManiaStatics.SYMBOL_HEIGHT * 0.9 + KitchenDramaSushiManiaStatics.REEL_Y_OFFSET - this._floaterContainer.y + KitchenDramaSushiManiaStatics.SYMBOL_HEIGHT * 0.45;
        }

        let text:TwoLayerText = this.createText(startPos, amount);

        this._floaterContainer.addChild(text);
        this._texts.push(text);
        this._textTls.push(tl);


        let targetPos = MathUtils.randomPosInRect(this._winAmountBoundingBox, this._winAmountBoundingBoxMask);
        //this._targetPositions.push(targetPos);

        let fastPoint = MathUtils.pointAlongLine(startPos, targetPos, 0.9);
        let targetRotation = this.getTargetRotation(this._centerPoint, targetPos);

        tl.add([
            gsap.to(text, {duration:0.1, alpha:1}),
            gsap.to(text.scale, {duration:0.3, x:1, y:1, ease:"back.out(2)"})
        ]);
        tl.add(gsap.to(text.position, {duration:0.8, x:fastPoint.x, y:fastPoint.y, ease:"power3.out"}), 0);
        tl.add(() => {
            gsap.to(text.position, {
                duration:2.5,
                x:targetPos.x,
                y:targetPos.y,
                ease:"none"
            });
        }, 0.6);

        tl.add(() => {
            gsap.to(text, 15.0, {rotation:targetRotation, ease:"none"});
        }, 0);

        return tl;

    }


    public getBuildUpAnimation(size:WinSize = WinSize.none):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.BLOB_SUCK)
            this._floaterAnimation = this.getSuckInFloaters();
        });
        tl.add(this.getBlob(size, 0.6), "<");
        return tl;
    }

    public clearFloaters(){
        if (this._floaterAnimation != undefined){
            this._floaterAnimation.progress(1);
        }
    }

    public getExplosionAnimation(finalAmount:number, winSize:WinSize, showFinalAmount:boolean = true):gsap.core.Timeline {
        let tl:gsap.core.Timeline = gsap.timeline();

        if (!showFinalAmount){
            this._finalAmountText = this.createText(this._centerPoint, 0, KitchenDramaSushiManiaTextStyles.WIN_AMOUNT_DISPLAY_NUMBERS_BIG_STYLE, KitchenDramaSushiManiaTextStyles.WIN_AMOUNT_DISPLAY_NUMBERS_BIG_STYLE);
            this._finalAmountText.visible = false;
        }else {
            this._finalAmountText = this.createText(this._centerPoint, finalAmount, KitchenDramaSushiManiaTextStyles.WIN_AMOUNT_DISPLAY_NUMBERS_BIG_STYLE, KitchenDramaSushiManiaTextStyles.WIN_AMOUNT_DISPLAY_NUMBERS_BIG_STYLE);
            this._finalAmountText.visible = true;
        }

        this._blackHoleContainer.addChild(this._finalAmountText);

        let winAmountTargetScale:number = 1;

        if (winSize == WinSize.none) {
            this._explosion.emitter.emitterLifetime = 0.0;
            this._explosion.emitter.minLifetime = 0.0;
            this._explosion.emitter.maxLifetime = 0.0;
            //this._explosion.emitter.endSpeed = -250;
            winAmountTargetScale = 0.4;
        } else if (winSize == WinSize.tiny) {
            this._explosion.emitter.emitterLifetime = 0.05;
            this._explosion.emitter.minLifetime = 0.8;
            this._explosion.emitter.maxLifetime = 1.2;
            this._explosion.emitter.startSpeed = PropertyNode.createList({start:800, end:-250});
            // this._explosion.emitter.endSpeed = -250;
            winAmountTargetScale = 0.55;
        } else if (winSize == WinSize.small) {
            this._explosion.emitter.emitterLifetime = 0.07;
            this._explosion.emitter.minLifetime = 0.9;
            this._explosion.emitter.maxLifetime = 1.7;
            this._explosion.emitter.startSpeed = PropertyNode.createList({start:800, end:-250});
            // this._explosion.emitter.endSpeed = -250;
            winAmountTargetScale = 0.7;
        } else if (winSize == WinSize.medium) {
            this._explosion.emitter.emitterLifetime = 0.09;
            this._explosion.emitter.minLifetime = 1.2;
            this._explosion.emitter.maxLifetime = 1.7;
            this._explosion.emitter.startSpeed = PropertyNode.createList({start:800, end:-100});
            // this._explosion.emitter.endSpeed = -100;
            winAmountTargetScale = 0.85;
        } else {
            this._explosion.emitter.emitterLifetime = 0.13;
            this._explosion.emitter.minLifetime = 1.5;
            this._explosion.emitter.maxLifetime = 2.0;
            this._explosion.emitter.startSpeed = PropertyNode.createList({start:800, end:0});
            winAmountTargetScale = 1.0;
        }


        let particleTween = this._explosion.tween;
        particleTween.timeScale(2);
        tl.add([
            particleTween,
            gsap.to(this._finalAmountText.scale,  {
                duration:0.4,
                x : winAmountTargetScale,
                y : winAmountTargetScale,
                ease : "back.out(3.5)"
            }),
            gsap.to(this._finalAmountText, {duration:0.01, alpha : 1})
        ]);

        tl.add(() => this.resetBlackHole());
        tl.add(gsap.to(this._finalAmountText, {duration:0.5, alpha : 0, delay : 0.2}));

        return tl;
    }

    public getBlob(winSize:WinSize, duration:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        let blobTargetScale:number = 0;
        if (winSize <= 1) {
            blobTargetScale = 0.6;
        } else if (winSize == 1) {
            blobTargetScale = 0.8;
        } else {
            blobTargetScale = 1.0;
        }

        tl.add(() => this.startBlackHole());
        tl.add(gsap.to(this._blackHole.scale, {
            duration:duration,
            x:blobTargetScale,
            y:blobTargetScale,
            ease:"power1.in"
        }));
        tl.add(() => this.stopBlackHole());
        tl.add(gsap.to(this._blackHole.scale, {duration:0.2, x:0, y:0, ease:"power4.in"}));

        return tl;
    }

    private startBlackHole() {
        this._blackHole.visible = true;
        this._blackHoleAnimation.play(0);
    }

    private stopBlackHole() {
        this._blackHole.visible = true;
        this._blackHoleAnimation.pause(0);
        this._blackHole.getAnimation([1, 0]);
    }

    private resetBlackHole() {
        this._blackHole.visible = false;
        this._blackHole.scale.set(0.1, 0.1);
        this._blackHoleAnimation.pause(0);

    }

    public getSuckInFloaters():gsap.core.Timeline {
        const tl = gsap.timeline();
        for (let tl of this._textTls) {
            tl.kill();
        }
        this._textTls = [];

        for (let text of this._texts) {
            gsap.killTweensOf(text);
            gsap.killTweensOf(text.scale);
            gsap.killTweensOf(text.position);
            const textTl = gsap.timeline();
            let targetRotation = this.getTargetRotation(this._centerPoint, text.position);
            textTl.add([
                gsap.to(text, {duration:0.7, rotation:targetRotation, ease:"none"}),
                gsap.to(text.position, {
                    duration:0.7,
                    x:this._centerPoint.x,
                    y:this._centerPoint.y,
                    ease:"back.in(2)"
                }),
                gsap.to(text.scale, {duration:0.4, x:0.1, y:3, delay:0.3, ease:"power1.in"})
            ]);
            textTl.add(text.showTop(0.4), 0.3);
            textTl.add(() => {
                this._floaterContainer.removeChild(text);
            })
            tl.add(textTl, 0);
        }
        this._texts = [];

        return tl;
    }


    private getTargetRotation(centerPosition:PIXI.Point, objectPosition:PIXI.Point) {
        let targetRotation:number = MathUtils.angleBetweenPoints(centerPosition, objectPosition);
        targetRotation += Math.PI / 2; //Fixes orientation
        if (objectPosition.y > centerPosition.y) {
            targetRotation -= Math.PI; //Flips text to be "right way up" if object is under center point
        }
        return targetRotation;
    }

    private createText(position:PIXI.Point, amount:number, topTextStyle:PIXI.TextStyle = KitchenDramaSushiManiaTextStyles.WIN_AMOUNT_TEXT_WHITE, bottomStyle:PIXI.TextStyle = KitchenDramaSushiManiaTextStyles.WIN_AMOUNT_TEXT):TwoLayerText {
        const textField:TwoLayerText = new TwoLayerText(KitchenDramaSushiMania.apiPlugin.currency.formatValue(amount), topTextStyle, bottomStyle);
        textField.position.set(position.x, position.y);
        textField.alpha = 0;
        textField.scale.set(0, 0);
        return textField;
    }


}